import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './consolidating-splash-screen.scss';

export const ConsolidatingSplashScreen = () => (
  <div className={styles.container}>
    <h1 className={styles.title}>
      <FormattedMessage id="consolidation.data_consolidating" defaultMessage="Your data is consolidating" />
    </h1>
    <h2 className={styles.subtitle}>
      <FormattedMessage
        id="consolidation.performance_metrics_available_soon"
        defaultMessage="Performance metrics will soon be available to view."
      />
    </h2>
    <div className={styles.image} />
  </div>
);
